import Link from 'next/link';

import { styled } from '@lichtblick/styled';
import { Colors } from '@lichtblick/theme';

export const Container = styled.div`
  align-items: center;
  color: ${Colors.blue[100]};
  cursor: pointer;
  display: inline-flex;
  gap: 0.75rem;
`;

export const StyledLink = styled(Link)<{ size: 'large' | 'small' }>`
  color: ${Colors.blue[100]};

  font-family: 'Roboto', sans-serif;
  font-feature-settings: 'case' on;
  font-size: ${({ size }) => (size === 'large' ? '1rem' : '0.75rem')};
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.03125rem;
  line-height: 120%;
  text-decoration: none;

  &:hover {
    color: ${Colors.darkBlue};
  }
`;
